/* eslint-disable react/display-name */
import React, { memo, useCallback } from 'react';
import Modal from 'react-responsive-modal';
import styled from 'styled-components';

import { translate } from '../../common/translation/translate';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { AlertsListHeader } from '../alerts/alertsListHeader';
import { AqiIndexLegend } from '../common/types';
import { AirQualityInfoContainer } from './airQualityInfoContainer';
import { aqiIndexLegend } from './constants';

const indexLegendArray = aqiIndexLegend;
const lastUpdatedTime = '';

interface AqiLegendPopupProps {
    open: boolean;
    onClose: () => void;
}
export const AqiLegendPopup = memo(({
    open = false,
    onClose
}: AqiLegendPopupProps) => {
    const onCloseEvent = useCallback(() => {
        onClose();
    }, []);

    return (
        <Modal open={open} onClose={onCloseEvent} styles={modalStyles} center={true}>
            <ModalHeader>
                <AlertsListHeader>{translate('aqiPopupHeaderText')}</AlertsListHeader>
            </ModalHeader>
            <MessageContainer>
                {indexLegendArray.map((value: AqiIndexLegend, index: number) => {
                    return (
                        <AirQualityInfoContainer 
                            key={index}
                            backgroundFillColor={value.backgroundFillColor}
                            index={value.indexRange }
                            aqiDescription={value.aqiDescription}
                            aqiTodaysConditions={value.recommendation}
                            lastUpdatedTime={lastUpdatedTime}
                        />
                    );
                })}
            </MessageContainer>
        </Modal>
    );
});

const modalStyles = {
    closeIcon: {
        fill: '#555555',
        width: 24,
        height: 24
    }
};

const ModalHeader = styled.h1`
    display: flex;
    flex-direction: row;
    padding: 0 0 0 15px;
    margin: 0;
    color: #555555;
    background-color: #FFFFFF;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: 600;
    width: 100%;

    .dvVwkQ {
        border-bottom: none;
    }
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    background-color: #F9F9F9;
    color: #555555;
    font-family: Source Sans Pro;
    font-size: 14px;
    font-weight: 400;
    white-space: pre-wrap;
    width: 470px;

    @media ${smallMediaQuery} {
        width: 100%;
    }
`;
